// extracted by mini-css-extract-plugin
module.exports = {"subscribeIcon":"BuoySubscribe_subscribeIcon__NHgqO","BuoySubPop":"BuoySubscribe_BuoySubPop__88z9R"};